<!--
  ~ Copyright (C) 2025 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<section class="feedback-providers-section" [id]="section?.uid">
  <div class="feedback-providers-section-top">
    <div class="feedback-providers-title large bold">{{ section?.title }}</div>
  </div>

  <div class="feedback-providers-section-inner">
    <mat-card class="feedback-providers-item" *ngFor="let item of feedbackProviders">
      <div class="provider-info-box">
        <div class="icon-box">
          <img width="225" height="225" [src]="item.image ? item.image : 'assets/profile_image.png'" alt="{{ item.name }}" />
        </div>
        <div class="provider-info">
          <div class="name medium bold">{{ item.name }}</div>
          <div class="position medium italic" *ngIf="item.jobTitle">{{ item.jobTitle }}</div>
          <div class="university medium" *ngIf="item.organization">{{ item.organization }}</div>
        </div>
      </div>
    </mat-card>
  </div>

  <div class="feedback-providers-section-bottom" *ngIf="section?.feedbackProviders.length > 3 && !allLoaded">
    <div class="medium">
      {{ 'translations.diagnostics.labels.feedbackProvidersMoreProviders' | transloco: { number: section?.feedbackProviders.length - 3 } }}
    </div>
    <a role="button" class="medium bold" tabindex="0" (click)="showMore()" (keydown.enter)="showMore()">
      {{ 'translations.global.button.seeMore' | transloco }}
    </a>
  </div>
</section>
